import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Utils from "../../Utils";
import Button from "../../lib/Button";
import { Profile } from "../../lib/game_snacks/IUser";
import Session, { game_type } from "../../Session";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class CreateProfilePopup extends Popup
{
    // #region Attributes //

    // private:

    private _gameType: game_type = null;

    // #endregion //


    public set gameType( value: game_type ) { this._gameType = value; }


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        

        console.assert( this._gameType !== null, "CreateProfilePopup.ts :: onEnter() :: this._gameType cannot be null." );

        this._disabledBg.alpha = 0;

        let base: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.popup_base.texture );
        base.position.set( ServiceLocator.app.width * 0.5 - base.texture.width * 0.5, ServiceLocator.app.height * 0.5 - base.height * 0.5 );
        this._root.addChild( base );

        let message: PIXI.Text = new PIXI.Text( "You need to create a profile to play online.", { 
            fontFamily: "jaro_regular", 
            fontSize: 38, 
            fill: 0xffffff,
            wordWrap: true,
            wordWrapWidth: ServiceLocator.app.width * 0.8,
            align: "center" } );
        message.anchor.set( 0.5 );
        message.position.set( base.texture.width * 0.5, 194 + 70 );
        base.addChild( message );

        let closeBtn: Button = new Button( { on: "popup_button_ok", pressed: "popup_button_ok_pressed" } );
        closeBtn.anchor.set( 0.5 );
        closeBtn.position.set( base.texture.width * 0.5, 350 + 80 );
        base.addChild( closeBtn );
        closeBtn.on( "pointertap", () => { this._onClosed.dispatch( this, null ); } );
    }

    // #endregion //
}